export default __webpack_public_path__ + "static/media/mad-ape-007.cc31d5aa.svg";